import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { Container, Typography, InputLabel, Paper, Divider, Grid, Button } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import SaveIcon from '@material-ui/icons/Save';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { ShopActions, NotificationActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
    },
    permission: {
        padding: '5px',
    },

    infoTitle: {
        "& h1": {
            float: 'left'
        },
        "& div": {
            width: '100px',
            display: 'block',
            margin: '0 0 5px auto'
        }
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const shopsSelector = (state) => state.Shops;
const IdentitySelector = (state) => state.Identity;

const ShopEntryStep3 = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const shopActions = bindActionCreators(ShopActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(shopsSelector);
    const { token } = useSelector(IdentitySelector);

    const { handleSubmit } = useForm();

    const { classes } = props;

    /**
     * 
     * 戻る押下時の処理
     * 
     */
    const onBackClick = () => {
        props.handleBack();
    }

    /**
     * 
     * 保存ボタン押下時の処理
     * （店舗情報（アカウント情報を内包）を保存）
     * 
     */
    const onSubmit = (data, e) => {
        // 店舗情報（アカウント情報を内包）を保存
        shopActions.save(token, editing)
            .then(data => {
                if (!data || data.error_code > 0) {
                    var message = '登録完了の通知メール送信に失敗しました。';
                    notificationActions.showWarn(message);
                }
                else {
                    // 登録メッセージ表示
                    notificationActions.showSuccess('登録しました。');
                }
                // 一覧画面に遷移
                props.handleNext();
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    return (
        <form className={classes.form} noValidate>
            <Grid container className={classes.form} spacing={2} >
                <Grid item xs={12}>
                    <Typography component="h1" variant="inherit">{<FormattedMessage id="Merchant.ConfirmTitle" />}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.ConfirmDesc"} /></InputLabel>
                </Grid>

                <Grid item xs={12}>
                    <Typography component="h1" variant="inherit">{<FormattedMessage id="Shop.ShopEntryStep1Title" />}</Typography>
                    <Divider />
                </Grid>

                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Shop.MerchantName"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.merchant_name}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Shop.Name"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.shop_name}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Shop.ShopFName"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.shop_f_name}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Shop.ShopEName"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.shop_e_name}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Shop.ShopPostalCd"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.shop_postal_cd}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Shop.ShopAddress"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.shop_adress}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Shop.ShopEAddress"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.shop_e_adress}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Shop.Latitude"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.latitude}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Shop.Longitude"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.longitude}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Shop.ShopTel"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.shop_tel}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Shop.ShopFax"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.shop_fax}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Shop.ShopType"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.shop_type == 1 ? '固定' : '可動式'}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Shop.ShopCd3"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.shop_cd_3}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Shop.DealsInfo"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.deals_info}</InputLabel>
                </Grid>
            </Grid>

            {!editing.isSkipAccount && (
                <Grid container className={classes.form} spacing={2} >
                    <Grid item xs={12}>
                        <Typography component="h1" variant="inherit">{<FormattedMessage id="Shop.ShopEntryStep2Title" />}</Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.AccountName"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.user_account_create_request.name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.Division"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend"><FormattedMessage id={"Account.Role.Store"} /></InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.MailAddress"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.user_account_create_request.username}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Account.Permission"} /></InputLabel>
                    </Grid>
                    {Object.keys(editing.user_account_create_request.permissions).map((fld) => {
                        var permission = editing.user_account_create_request.permissions[fld];
                        return (
                            <Grid container className={classes.permission} spacing={2}>
                                <Grid item xs={4}>
                                </Grid>
                                <Grid item xs={4}>
                                    <InputLabel component="legend">{permission.type.name}</InputLabel>
                                </Grid>
                                <Grid item xs={2}>
                                    <InputLabel component="legend">{permission.value.title}</InputLabel>
                                </Grid>
                            </Grid>
                        )
                    })}
                </Grid>
            )}

            <Grid container item xs={12} spacing={2} justify="center">
                <Grid item xs={6}>
                    <Button fullWidth variant="contained" size="medium"
                        startIcon={<ArrowBackIosIcon />}
                        onClick={onBackClick}><FormattedMessage id="Button.Back" /></Button>
                </Grid>
                   <Grid item xs={6}>
                    <Button fullWidth variant="contained" size="medium" color="primary"
                        onClick={handleSubmit(onSubmit)}
                        endIcon={<SaveIcon />}><FormattedMessage id="Button.Register" /></Button>
                </Grid>
            </Grid>
        </form>
    )
}

export default withStyles(style, { withTheme: true })(ShopEntryStep3);
